export function getPhoneStatusBorderClass(status: number | undefined): string {
	if (status === 1) return 'border-l-chart-5';
	if (status === 2) return 'border-l-chart-2';
	if (status === 3) return 'border-l-destructive';
	return 'border-l-muted-foreground/40';
}
